var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 588.8 363.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M211.3 1.1c-.8-1.4-2.9-1.4-3.7 0L78.4 224.9c-.4.7-1.1 1.1-1.8 1.1H8c-1.6 0-2.7 1.8-1.8 3.2l34.2 59.4c.4.7.4 1.5 0 2.1L.3 360.1c-.8 1.4.2 3.2 1.8 3.2H71c.8 0 1.5-.4 1.8-1.1l134.8-233.5c.8-1.4 2.9-1.4 3.7 0l136.1 233.5c.4.7 1.1 1.1 1.8 1.1h67.5c1.6 0 2.7-1.8 1.8-3.2L211.3 1.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M242.7 239.3c-.8-1.4-2.9-1.4-3.7 0l-70 120.8c-.8 1.4.2 3.2 1.8 3.2h68.8c.8 0 1.5-.4 1.8-1.1l35.5-61.5c.4-.7.4-1.5 0-2.1l-34.2-59.3zM588.6 360.1L379.9 1.1c-.8-1.4-2.9-1.4-3.7 0l-65.7 113.8c-.4.7-.4 1.5 0 2.1l33.9 60.4c.8 1.4 2.9 1.5 3.7 0l28.1-48.6c.8-1.4 2.9-1.4 3.7 0l135.2 233.5c.4.7 1.1 1.1 1.8 1.1h69.7c1.8-.1 2.8-1.8 2-3.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ccaa3f3f035542c914efd9589111337a.svg";
export { ForwardRef as ReactComponent };